/**
 * Employment contract types (Employee.contractType) and their French labels.
 *
 * Besides CDI, CDD and STAGE, a type exists for each worker category of
 * form Pr-RCS/Cot 04 (column 14 of the BNATS Pr-RCS/Cot 06) that no
 * duration settles: seconded civil servant (F), vocational student (E) and
 * national volunteer (N). The CNSS branches of each type are the dated
 * parameter CNSS_BRANCHES_BY_CONTRACT (cnss-branches.ts).
 */
export const CONTRACT_TYPES = [
    "CDI",
    "CDD",
    "STAGE",
    "FONCTIONNAIRE_DETACHE",
    "ELEVE_ETUDIANT",
    "VOLONTAIRE_NATIONAL",
];
/** Short label, for tables, filters and the payslip. */
export const CONTRACT_TYPE_LABELS = {
    CDI: "CDI",
    CDD: "CDD",
    STAGE: "Stage",
    FONCTIONNAIRE_DETACHE: "Fonctionnaire détaché",
    ELEVE_ETUDIANT: "Élève/Étudiant",
    VOLONTAIRE_NATIONAL: "Volontaire national",
};
/** Long label, for the employee form's contract choice. */
export const CONTRACT_TYPE_OPTION_LABELS = {
    CDI: "CDI — contrat à durée indéterminée",
    CDD: "CDD — contrat à durée déterminée",
    STAGE: "Stage",
    FONCTIONNAIRE_DETACHE: "Fonctionnaire détaché",
    ELEVE_ETUDIANT: "Élève ou étudiant d'une école professionnelle",
    VOLONTAIRE_NATIONAL: "Volontaire national",
};
export function isContractType(value) {
    return typeof value === "string" && CONTRACT_TYPES.includes(value);
}
//# sourceMappingURL=contract-types.js.map